import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"mb-8 terms-and-condition-section\">\n  <p class=\"{{this.termsAndConditionsClass}} body-1 terms-conditions\">\n    {{this.termsAndConditionsWithLegalName}}\n  </p>\n</div>", {
  moduleName: "@qonto/ui-kit/components/pdf-preview/terms-and-conditions.hbs"
});